import { useSelector } from 'react-redux';

import {
  selectFormVersion,
  selectPaymentFormSchema,
} from '@cashier/cashier-data-access';
import { PaymentFormSchema } from '@cashier/cashier-model';

interface UseFormData {
  schema: PaymentFormSchema | null;
  version: string;
}

export const useFormData = (): UseFormData => {
  return {
    schema: useSelector(selectPaymentFormSchema),
    version: useSelector(selectFormVersion),
  };
};
